<table class="meter-list" aria-describedby="meter-list">
  <th scope="sonarqubefix" class="sonarqubefix"></th>
  <tr class="header">
    <td class="col1">{{ 'module.meterReading.measuringSystemHeaderButtonText' | translate }}</td>
    <td class="col2">{{ 'module.meterReading.typeHeaderButtonText' | translate }}</td>
    <td class="col3">{{ 'module.energyMap.descriptionComponent.objectTypes' | translate }}</td>
    <td class="col4" *ngIf="!!authService.permissions.SENSOR_DATA">{{ 'module.meterReading.meterNumberMarketLocationSensorNumberHeaderText' | translate }}</td>
    <td class="col4" *ngIf="!authService.permissions.SENSOR_DATA">{{ 'module.meterReading.meterNumberMarketLocationHeaderText' | translate }}</td>
  </tr>
  <tr *ngFor="let meter of isMeterListLoading ? [] : data.meters" class="building-meters">
    <td class="col1 table-cell meter-type">
      <app-svg-icon
        class="table-icon measuring-system-icon"
        [ngClass]="{ 'center-icon': meter.deviceId !== null }"
        src="./assets/icons/{{ meter | getMeterTypeImage }}"
        title="{{ meter.deviceId === null ? meter.meterType?.name : ('module.meterReading.remoteName' | translate) }}"
      ></app-svg-icon>
    </td>
    <td class="col2 table-cell type">
      <img alt="energy-type-img" class="table-icon" src="./assets/icons/{{ meter.energyType.name | getEnergyTypeImage }}" title="{{ meter.energyType.name }}" />
    </td>
    <td class="col3 table-cell">
      <div class="object-type">
        <ng-container *ngTemplateOutlet="!!!meter.isEdit ? displayBuildingType : editObjectType; context: { meter: meter }"> </ng-container>
      </div>
    </td>
    <td class="col4 table-cell meter-number">
      <div class="nummer">
        <div class="row" matTooltipClass="matTooltip-meter-list-Z">
          <div>Z:</div>
          <div>
            <div class="chunk">
              {{ meter.meterNumber }}
            </div>
          </div>
        </div>
        <div class="row" matTooltipClass="matTooltip-meter-list-M">
          <div>M:</div>
          <div>
            <div class="chunk">
              {{ meter.marketLocationKey }}
            </div>
          </div>
        </div>
        <div class="row" *ngIf="meter.device" [matTooltip]="meter.device.onboardingKey">
          <div>S:</div>
          <div>
            <div class="chunk">
              {{ meter.device.onboardingKey }}
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>
</table>
<app-notification-card
  class="app-notification-card"
  type="info"
  text="{{ 'module.meterReading.noResultsFoundText' | translate }}"
  *ngIf="data.meters.length <= 0 && isMeterListLoading === false"
>
</app-notification-card>
<div class="meter-list-loading" *ngIf="isMeterListLoading">
  <span class="fa fa-spinner fa-spin fa-3x"></span>
</div>

<ng-template #displayBuildingType let-meter="meter">
  <ng-container *ngTemplateOutlet="meter.buildingType?.name ? displayObjectTypeName : noBuilding; context: { objectType: meter.objectType }"> </ng-container>
  <span *ngIf="!!authService.permissions.BUILDING_TYPE_UPDATE" class="fa fa-pencil" (click)="meter.isEdit = true"></span>
</ng-template>

<ng-template #editObjectType let-meter="meter">
  <mat-select [(ngModel)]="meter.buildingType" disableOptionCentering disableRipple [matTooltip]="meter.building?.buildingType.name">
    <mat-option *ngFor="let objectType of buildingTypes; trackBy: trackByFn" [value]="objectType" (click)="save(meter)">
      {{ objectType.name }}
    </mat-option>
  </mat-select>
</ng-template>

<ng-template #displayObjectTypeName let-objectType="objectType">
  <div matTooltipPosition="above" matTooltipClass="display-object-type" class="type-name" [matTooltip]="objectType">
    {{ objectType }}
  </div>
</ng-template>

<ng-template #noBuilding>
  <app-svg-icon
    matTooltip=" {{ 'module.meterReading.objectHoverMessage' | translate }}"
    matTooltipPosition="above"
    matTooltipClass="object-hover-message"
    class="icon-info"
    src="./assets/icons/ep_info_icon.svg"
  ></app-svg-icon>
  {{ 'module.meterReading.objectTypeIsNull' | translate }}
</ng-template>
